<template>
<div class="home-success" v-if="vistables">
  <div class="setimg">
  <img src="./chenggong.png" alt width="100%" height="100%">
  </div>
  <p>{{ $t('team.index.increase') + ' ' + $t('betting.title') }}</p>
</div>
</template>

<script>
  export default {
    props:{
      vistables:{
        type:Boolean,
        default:false
      }
    },
  };
</script>

<style scoped lang="scss">
.home-success{
  position: fixed;
  top:45%;
  left:50%;
  margin-left:-150px;
  width: 260px;
  height: 162px;
  background-color: #fff;
  box-shadow: 0px 2px 7px 0px rgba(48, 48, 48, 0.2);
  border-radius: 6px;
  overflow: hidden;
  z-index:999;
  .setimg{
    width: 64px;
    height: 64px;
    overflow: hidden;
    margin: 30px auto 10px;
  }
  p{
    font-family: ArialMT;
    font-size: 18px;
    color: #8c8c8c;
    text-align: center;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/build902/components/new-home/R-side/prompt.vue